import React from 'react';

import { useListMembershipTypes } from 'src/features/membershipType/api/useListMembershipTypes';
import { MEMBERSHIP_TEMPLATE_CATEGORY } from 'src/features/membershipType/types';
import { useParking } from 'src/providers/ParkingProvider';

type Props = {
    children: React.ReactNode;
    category: MEMBERSHIP_TEMPLATE_CATEGORY;
};

export default function MembershipCategoryWrapper({ children, category }: Props) {
    const { parkingId } = useParking();
    const { data: membershipTypes } = useListMembershipTypes({
        category,
        parkingId,
        is_active: true,
    });

    return (membershipTypes && membershipTypes.count) || category === MEMBERSHIP_TEMPLATE_CATEGORY.CUSTOM
        ? children
        : null;
}
